// Accounts API endpoints

import { apiClient } from './client';
import type { AccountDetailResponse, OrderListResponse, OrderDetailResponse } from '../types/api';

/**
 * Account management API functions
 */
export const accountsApi = {
  /**
   * Get account details with positions
   *
   * @param accountId - Account string identifier (e.g. "USER-12345678"), NOT UUID
   * @returns Account details including positions
   */
  getAccount: (accountId: string): Promise<AccountDetailResponse> => {
    return apiClient.get<AccountDetailResponse>(`/api/accounts/${accountId}`);
  },

  /**
   * List orders for an account
   *
   * @param accountId - Account string identifier (e.g. "USER-12345678"), NOT UUID
   * @param params - Query parameters (status, symbol, from_date, to_date, limit, offset)
   * @returns Paginated list of orders
   */
  listOrders: (accountId: string, params?: Record<string, string>): Promise<OrderListResponse> => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return apiClient.get<OrderListResponse>(`/api/accounts/${accountId}/orders${queryString}`);
  },

  /**
   * Get a specific order by client order ID
   *
   * @param accountId - Account string identifier (e.g. "USER-12345678"), NOT UUID
   * @param clientOrderId - Client order ID
   * @returns Order details
   */
  getOrder: (accountId: string, clientOrderId: string): Promise<OrderDetailResponse> => {
    return apiClient.get<OrderDetailResponse>(`/api/accounts/${accountId}/orders/${clientOrderId}`);
  },
};
